<template>
    <v-text-field :value="amount"              
                  :label="label"
                  v-on:keydown="onKeydown($event)" 
                  v-on:focus="onGetFocus($event)" 
                  v-on:change="callChange" :dense="isDense" :readonly="isReadOnly" :prefix="prefix" 
                  :class="{'text-field-style': isReadOnly, 'text-grey': isReadOnly, 'amount-alignment': true, 'input-align-right': true}">
    </v-text-field> 
  </template>
  
  <script>
    export default {
      props: {
        amount: String,
        field: String,
        label: String,
        prefix: String,
        isDense:{
          type: Boolean,
          default: true
        },
        isReadOnly: {
          type: Boolean,
          default: false
        }
      },
      methods:{
        onGetFocus(evt){
          try{
            evt.target.select();
          } catch(err){ 
            console.log(err.message);
          }
        }, 
        onKeydown(e) {

          let allowedalphakeys = [8, 9, 188, 46, 35, 36, 37, 39]; // backspace, tab, ',', delete, home, end, left, right  
          let allowedctrlkeys = [65, 67, 88, 86]; // ctrl-a, ctrl-c, ctrl-v, ctrl-x
          let allowednumpadkeys = [109]; // '-'

          // '.' in numpad is changed to ',' here
          if(e.keyCode === 110){
            e.target.value+=',';
          }

          if (!(
              ((e.keyCode >= 48 && e.keyCode <= 57) && !e.shiftKey)
              || (e.keyCode == 189 && !e.shiftKey)
              || (e.keyCode >= 96 && e.keyCode <= 105)
              || allowedalphakeys.includes(e.keyCode)
              || (allowedctrlkeys.includes(e.keyCode) && e.ctrlKey)
              || (allowednumpadkeys.includes(e.keyCode))
          )) {               
              e.preventDefault();
          }          
        },
        toDutchNumberFormat(value) {

          // decimal seperator must be "," for input value          
          if(value != null && value != '' && value != '0') {  

              // multiple comma's? keep the one on the right side  
              try{
                if(value.match(/,/g||[]).length > 1){
                  let new_value=[];
                  [...value].forEach((el, i) => {
                    if(el !== "," || (el === "," && i === value.lastIndexOf(','))){                    
                      new_value.push(el);
                    }
                  });            
                  value = new_value.join('');
               }
              } catch(err){ /* do nothing */ }

              // replace any comma (just one here) with a dot = JS numberformat 
              if((""+value).includes(",")) { // is NL format?  (JS number format only contains a decimal dot --> not a thousand separator comma)        
                  value = ((""+value).replace(".", "")).replace(",", "."); // first restore JS number format if needed then return NL format for complete value
              } 

              // if there is a hyphen it must be placed in fornt of the value
              if((""+value).includes("-")) { 
                  value = "-" + value.replaceAll("-", "");
              }      
        
              // return the number with 2 fixed decimals
              return new Intl.NumberFormat('nl-NL', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(+value);

          } else { // no value, return 0
              return '0';
          }
        },      
        callChange(data){
          data=this.toDutchNumberFormat(data);
          this.$emit('updateData',  {"field": this.field, "value": data});
        }       
      }    
    }
  </script>
  
  <style scoped>
    .amount-alignment{
      text-align: right;
    }
    .input-align-right >>> input {
      text-align: right;
    }

    .text-field-style >>> .v-text-field__slot input {
        color: grey;
        font-weight: 300; /* 800 being bold so this is less than half bold */
    }    
    .text-grey {
        color: grey !important;
        font-weight: 400 !important; /* 800 being bold so this is half bold */
    }       
  </style>